import { type InjectionKey, type Ref, inject, ref } from "vue";
import type { GlobalDataResource } from "@carnet/api/backoffice";

// Référentiel global (settings d'upload, types d'immersion…) fourni par l'app hôte via `provide`
// au niveau racine (cf. app.vue), sur le modèle de [[currentMemberIdKey]]. Les composants
// partagés (@carnet/ui) le consomment sans dépendre d'un composable plateforme : `useGlobalData`
// a une signature async côté web / sync côté mobile, l'inject masque cette différence. Une app
// qui ne le fournit pas obtient `null` (les composants retombent sur les valeurs par défaut).
export const globalDataKey = Symbol("globalData") as InjectionKey<Ref<GlobalDataResource | null>>;

const fallback = ref<GlobalDataResource | null>(null);

export function useAppGlobalData(): Ref<GlobalDataResource | null> {
  return inject(globalDataKey, fallback);
}
